import { mountVideoPlayer } from 'frontend/unpoly/javascripts/video_player/component'
import type { VideoPlayerData } from '../video_player/types'
import type { CompilerMeta } from 'types/unpoly/compiler'

up.compiler('[data-player]', (element: HTMLElement, data: VideoPlayerData, meta: CompilerMeta) =>
  mountVideoPlayer(element, data, { skipVisitBookkeeping: meta.revalidating }),
)
